let qs = ((a) => {
    if (a == '') return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1) b[p[0]] = '';
        else b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
    }
    return b;
})(window.location.search.substr(1).split('&'));

let hasSessionStorage = () => {
    return !!window && !!window.sessionStorage;
};

module.exports.getQueryParameterFromUrl = (key) => qs[key];

module.exports.hasSessionStorage = hasSessionStorage;

module.exports.getFromSessionStorage = (key) => {
    if (!key) return false;
    if (!hasSessionStorage()) return false;

    return window.sessionStorage.getItem(key);
};

module.exports.getScriptFullPath = () => {
    let scripts = document.getElementsByTagName('script');
    let arr = [];
    for (var i in scripts) {
        arr.push(scripts[i]);
    }
    return (
        arr.filter((script) => /ifhelp2015\.js/.test(script.src)).map((script) => script.src)[0] ||
        arr
            .filter((script) => /ifhelp2015webpack\.js/.test(script.src))
            .map((script) => script.src)[0]
    );
};

module.exports.getScriptOrigin = () => this.getScriptFullPath()?.replace(/ifhelp2015\.js.*/, '');

module.exports.getUTCdatetime = (date) => {
    date = date || new Date();

    return new Date(
        Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        )
    );
};
